import React from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Row,
  TextArea,
  TextField,
  Select,
  Label,
} from '@folio/stripes-components';
import { FieldArray } from 'react-final-form-arrays';
import { FormattedMessage, useIntl } from 'react-intl';
import { Field } from 'react-final-form';
import LocalizedTextField from '../LocalizedTextField';
import css from './styles.css';

function HelpeEditForm(props) {
  const { formatMessage } = useIntl();
  const linkTargetOptions = [
    {
      label: formatMessage({
        id: 'ui-plugin-inventory-templates.helpeEditForm.linkTargetOptions.select.chooseMsg',
        defaultMessage: 'Choose link target',
      }),
      value: '',
    },
    {
      label: formatMessage({
        id: 'ui-plugin-inventory-templates.helpeEditForm.linkTargetOptions.blank',
        defaultMessage: 'Open in new tab',
      }),
      value: '_blank',
    },
    {
      label: formatMessage({
        id: 'ui-plugin-inventory-templates.helpeEditForm.linkTargetOptions.self',
        defaultMessage: 'Open in the same frame as it was clicked',
      }),
      value: '_self',
    },
    {
      label: formatMessage({
        id: 'ui-plugin-inventory-templates.helpeEditForm.linkTargetOptions.parent',
        defaultMessage: 'Open in the parent frame',
      }),
      value: '_parent',
    },
    {
      label: formatMessage({
        id: 'ui-plugin-inventory-templates.helpeEditForm.linkTargetOptions.top',
        defaultMessage: 'Open in the full body of the window',
      }),
      value: '_top',
    },
  ];
  return (
    <>
      <Row>
        <Col xs={6}>
          <Label>
            <FormattedMessage
              id="ui-plugin-inventory-templates.defaultFields.editForm.formFields.helpeText.label"
              defaultMessage="Helpe text"
            />
          </Label>
        </Col>
      </Row>
      <div className={css.container}>
        <Row>
          <Col xs={12}>
            <FieldArray
              name="helpeText.content"
              component={LocalizedTextField}
              fieldComponent={TextArea}
              fieldLabel={
                <FormattedMessage
                  id="ui-plugin-inventory-templates.defaultFields.editForm.formFields.helpeText.content"
                  defaultMessage="Content"
                />
              }
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Field
              component={TextField}
              fullWidth
              fitContent
              name="helpeText.helpeLink"
              label={
                <FormattedMessage
                  id="ui-plugin-inventory-templates.defaultFields.editForm.formFields.helpeText.helpeLink"
                  defaultMessage="Link"
                />
              }
              type="text"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Field
              component={Select}
              fullWidth
              fitContent
              name="helpeText.linkTarget"
              label={
                <FormattedMessage
                  id="ui-plugin-inventory-templates.defaultFields.editForm.formFields.helpeText.linkTarget"
                  defaultMessage="Target"
                />
              }
              dataOptions={linkTargetOptions}
              type="text"
            />
          </Col>
        </Row>
      </div>
    </>
  );
}

HelpeEditForm.propTypes = {};

export default HelpeEditForm;
